import { render } from "./SeColorPicker.vue?vue&type=template&id=64bbac8d&scoped=true&ts=true"
import script from "./SeColorPicker.vue?vue&type=script&lang=ts"
export * from "./SeColorPicker.vue?vue&type=script&lang=ts"

import "./SeColorPicker.vue?vue&type=style&index=0&id=64bbac8d&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bbac8d"]])

export default __exports__